import ListLoadController from "./list_load_controller";

export default class extends ListLoadController
{
    initialize()
    {
        this.loadList()
    }

    loadList()
    {
        this.fetchForTarget(window.App.prefixedUrl(`/bad-phones/list`), this.listTarget)
            .then(() =>
            {
                App.$iconify.scanDOM();
            })
            .finally(() =>
            {
                this.hideLoading();
            });
    }
}